import { Label, Textarea } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function TextareaDemo() {
  return (
    <Section
      id="textarea"
      title="Textarea"
      description="Multi-line text input. No auto-grow by default; wire it from the consumer."
    >
      <VariantBlock label="States">
        <div className="grid w-80 gap-3">
          <div className="grid gap-1.5">
            <Label htmlFor="ta-default">Description</Label>
            <Textarea id="ta-default" placeholder="Tell us about it…" />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="ta-disabled">Disabled</Label>
            <Textarea id="ta-disabled" disabled defaultValue="Read-only..." />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="ta-invalid">Invalid</Label>
            <Textarea
              id="ta-invalid"
              aria-invalid
              defaultValue="Something's off here."
            />
          </div>
        </div>
      </VariantBlock>

      <VariantBlock label="Larger rows">
        <Textarea
          rows={8}
          className="w-80"
          placeholder="Plenty of room for long-form input."
        />
      </VariantBlock>
    </Section>
  );
}
